import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import IGFly from "../../../assets/img/Featured/fly-tap-pay-tall.png";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-drinks.png";
import IGQuickPay from "../../../assets/img/Featured/app-qr-quickpay.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../../components/Header";

const CasinoFloorPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page casinoFloorPage">
            <Header />
            <div className="page-header">Casino</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Casino Floor</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Ensure your patrons can focus on the game or 
                    slot, not on finding a server. Individual QR codes 
                    identify each machine or position at a table for 
                    self-service ordering, so the servers know exactly 
                    where to deliver their orders without any 
                    interruptions. Or enable servers to take orders and 
                    accept payment wherever the patron is with 
                    mobile all-in-one devices.
                </div>

            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Casino - Casino Floor", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                    <img src={InfoGenesis} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Casino - Casino Floor", "IG Fly");
                    addFlow("IG Fly");
                    navigate("/solutions/ig-fly")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Fly
                    </div>
                    <img src={IGFly} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Casino - Casino Floor", "IG OnDemand");
                    addFlow("IG OnDemand");
                    navigate("/solutions/ig-on-demand")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                    <img src={IGOnDemand} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Casino - Casino Floor", "IG Quick Pay");
                    addFlow("IG Quick Pay");
                    navigate("/solutions/ig-quick-pay")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Quick Pay
                    </div>
                    <img src={IGQuickPay} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default CasinoFloorPage;